import { render, staticRenderFns } from "./search-authority-editor.vue?vue&type=template&id=c4daf536&scoped=true&"
import script from "./search-authority-editor.vue?vue&type=script&lang=js&"
export * from "./search-authority-editor.vue?vue&type=script&lang=js&"
import style0 from "./search-authority-editor.vue?vue&type=style&index=0&id=c4daf536&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4daf536",
  null
  
)

export default component.exports